export const CURRENT_ODDS_MODULE = {
  ACTION_TYPES: {
    oddsChange: 'oddsChange',
    toggleOddsMenu: 'toggleOddsMenu'
  }
}
